import FlashContext from "components/FlashMessages/FlashContext";
import { Lock } from "components/icons/generated";
import Button from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";
import useTypedContext from "hooks/useTypedContext";
import useUnlockStack from "shared/Stack/useUnlockStack";

type UnlockButtonProps = {
  stackId: string;
  disabledTooltip?: string;
};

const UnlockButton = ({ stackId, disabledTooltip }: UnlockButtonProps) => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [stackUnlock, { loading }] = useUnlockStack({ refetchQueries: ["GetStack"] });

  const onClick = () => {
    stackUnlock({ id: stackId }, (data) => {
      if (data?.stackUnlock) {
        reportSuccess({ message: "Stack successfully unlocked" });
      }
    });
  };

  return (
    <Tooltip
      active={!!disabledTooltip}
      on={(tooltipProps) => (
        <Button
          {...tooltipProps}
          disabled={loading || !!disabledTooltip}
          loading={loading}
          onPress={onClick}
          startIcon={Lock}
          variant="secondary"
        >
          Unlock
        </Button>
      )}
      placement="top"
    >
      {disabledTooltip}
    </Tooltip>
  );
};

export default UnlockButton;
